<style scoped></style>

<template>
  <div class="c-page u-relative">
    <section
      data-color="clear"
      class="u-relative u-fit-w u-bg--brand-dark u-overflow-h js-header-panel pos-fix-availabel"
    >
      <div
        class="c-page__header o-wrapper--panel"
        :style="
          'transform:translateX(' +
            headerPageSize[2] +
            'px) translateY(' +
            headerPageSize[3] +
            'px) scale(' +
            headerPageSize[4] +
            ')'
        "
      >
        <img
          src="/static/HeadImages/salameh-illustraction.svg"
          alt="SVG Image"
        />
      </div>
      <div class="o-wrapper--valign u-viewport-fit-h u-fit-w">
        <div
          class="u-relative u-inline-block u-valign-middle u-marg-t-vh1of10 u-fit-w u-pad-l-w3of12 u-pad-l-w2of12@xl u-pad-r-w4of12 u-pad-r-w3of12@xl u-pad-x-w1of12@sm"
        >
          <h1
            class="t-h2-main-title-marine-holdings c-page__subtitle   t-text-lh--md u-color--black "
            v-html="content.subtitle"
          ></h1>
          <div class="introduction__inner">
            <div class="introduction__borderLeft scroll">
              <div class="scroll">
                <span class="background"></span>
                <span class="triangle"></span>
                <span class="label">Scroll to discover</span>
              </div>
            </div>
            <div class="introduction__titles">
              <div class="introduction__titlesInner">
                <div class="introduction__subtitle">
                  <h1 class="t-h3 t-text--roman t-text-lh--md u-color--black">
                    <app-sliced-text :content="content.title"></app-sliced-text>
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      data-color="dark"
      class="c-about__section-hight u-relative u-pad-y-xxl u-pad-y-lg@md u-bg--gray-lighter js-header-panel"
    >
      <div
        class="c-about__section-hight__wrapper u-marg-l-w3of12 u-marg-x-w3of12@lg u-marg-l-w1of12@sm u-w4of12 u-w1of2@lg u-w10of12@sm"
      >
        <div
          :key="index"
          v-for="(item, index) in content.content_blocks"
          :class="{ 'u-marg-t-lg': 'title' === item.type.value && index > 0 }"
        >
          <app-scroll-object
            :offset="0"
            :isParallax="!1"
            inline-template
            :content="item"
          >
            <div class="u-marg-x-auto u-fit-w">
              <h2
                class="t-text--xxl t-text-lh--lg t-text--roman u-color--brand-darker"
                v-if="content.type.value === 'title'"
              >
                <app-words
                  :isActive="isActive"
                  :delay="0"
                  :content="content.content"
                ></app-words>
              </h2>
              <p
                class="t-text--xl u-color--gray t-text-lh--xl"
                v-if="content.type.value === 'default'"
                :class="{ 'u-marg-t-md': index > 0 }"
                v-html="content.content"
              ></p>
            </div>
          </app-scroll-object>
        </div>
      </div>
    </section>
    
    <section
      class="u-relative  u-bg--white u-align-center u-pad-x-w2of12 u-pad-t-sm u-overflow-h js-facts-section js-header-panel"
      data-color="dark"
    >
      
      <app-scroll-object
        :offset="250"
        :isParallax="!1"
        inline-template
        :content="content"
      >
        <div
          class="c-about__fact c-about__fact--1 u-relative u-marg-x-auto u-align-left u-pad-y-xxl u-vacuum js-fact u-pad-y-xl@sm"
        >
          <div
            class="u-relative u-inline-block u-valign-top u-w6of12 u-fit-w@sm u-marg-b-xl@sm"
          >
            <img
              style="width:220px;"
              src="/static/HeadImages/Salameh-Iso.svg"
              alt="SVG Image"
            />
            <span
              class="c-about__fact__big-number t-text--roman u-relative u-marg-l-lg u-color--brand-blue"
            ></span>
            <span
              class="t-h1 u-color--brand-blue"
              v-html="content.second_section_number"
            ></span>
          </div>
          <div class="u-inline-block u-align-left u-w1of2 u-w2of2@sm">
            <h3
              class="t-h3 t-text--roman t-text-lh--xl u-color--brand-dark u-marg-b-md"
            >
              <app-words
                :isActive="isActive"
                :delay="0"
                :content="content.second_section_title"
              ></app-words>
            </h3>
          </div>
        </div>
      </app-scroll-object>
    </section>
    <section
      class="u-relative  u-bg--gray-lighter u-align-center u-pad-x-w2of12 u-pad-t-sm u-overflow-h js-facts-section js-header-panel"
      data-color="dark"
    >
      <div
        class="c-about__section-hight__wrapper u-marg-t-xl u-marg-l-w3of12 u-marg-x-w3of12@lg u-marg-l-w1of12@sm u-w4of12 u-w1of2@lg u-w10of12@sm"
      >
        <app-scroll-object
          :offset="0"
          :isParallax="!1"
          inline-template
          :content="content"
        >
          <div class="u-marg-x-auto u-fit-w">
            <h2
              class="t-text--ultra t-text-lh--lg t-text--roman u-color--brand-darker"
            >
              <app-words
                :isActive="isActive"
                :delay="0"
                :content="content.Keyfigures"
              ></app-words>
            </h2>
          </div>
        </app-scroll-object>
      </div>
      <!--
      <div
        class="c-about__fact c-about__fact--4 u-relative u-marg-x-auto u-flex u-flex-ai--center u-flex-fd--column@sm u-pad-y-xxl js-fact u-pad-y-xl@sm"
      >
        <app-scroll-object
          :offset="100"
          :isParallax="!1"
          inline-template
          :content="content"
        >
          <div class="c-about__fact--3__col-left u-w5of12 u-fit-w@sm">
            <h6
              class="c-about__fact__offse-letter t-h2  t-text--roman u-color--brand-blue u-marg-b-xs u-marg-b-0@sm u-pad-r-w1of24 u-align-left"
              v-html="content.fiftha_section_left_number_splitted"
            ></h6>
            <p
              class="t-text--md t-text--roman u-color--gray t-text-lh--md u-w7of10 u-fit-w@sm u-align-left"
            >
              <app-words
                :isActive="isActive"
                :delay="0"
                :content="content.fiftha_section_left_text"
              ></app-words>
            </p>
          </div>
        </app-scroll-object>
        <app-scroll-object
          :offset="100"
          :isParallax="!1"
          inline-template
          :content="content"
        >
          <div
            class="c-about__fact--3__col-right u-relative u-pad-l-w1of12 u-pad-l-0@sm u-w7of12 u-fit-w@sm"
          >
            <h6
              class="c-about__fact__offse-letter t-h2  t-text--roman u-color--brand-blue u-marg-b-xs u-marg-b-0@sm u-pad-r-w1of24 u-align-left"
              v-html="content.fifth_section_left_number_splitted"
            ></h6>
            <p
              class="t-text--md t-text--roman u-color--gray t-text-lh--md u-w7of10 u-fit-w@sm u-align-left"
            >
              <app-words
                :isActive="isActive"
                :delay="0"
                :content="content.fifth_section_left_text"
              ></app-words>
            </p>
            <span
              class="u-absolute u-pos-tl u-hide@sm u-fit-h c-line--y u-bg--gray u-opacity--30"
            ></span>
          </div>
        </app-scroll-object>
      </div>
      -->
      <div
        class="c-about__fact c-about__fact--4 u-relative u-marg-x-auto u-flex u-flex-ai--center u-flex-fd--column@sm u-pad-y-xxl js-fact u-pad-y-xl@sm"
      >
        <app-scroll-object
          :offset="100"
          :isParallax="!1"
          inline-template
          :content="content"
        >
          <div class="c-about__fact--3__col-left u-w5of12 u-fit-w@sm">
            <h6
              class="c-about__fact__offse-letter t-h2  t-text--roman u-color--brand-blue u-marg-b-xs u-marg-b-0@sm u-pad-r-w1of24 u-align-left"
              v-html="content.eighth_section_left_years_splitted"
            ></h6>
            <p
              class="t-text--md t-text--roman u-color--gray t-text-lh--md u-w7of10 u-fit-w@sm u-align-left"
            >
              <app-words
                :isActive="isActive"
                :delay="0"
                :content="content.eighth_section_left_text"
              ></app-words>
            </p>
          </div>
        </app-scroll-object>
        <app-scroll-object
          :offset="100"
          :isParallax="!1"
          inline-template
          :content="content"
        >
          <div
            class="c-about__fact--3__col-right u-relative u-pad-l-w1of12 u-pad-l-0@sm u-w7of12 u-fit-w@sm"
          >
            <h6
              class="c-about__fact__offse-letter t-h2  t-text--roman u-color--brand-blue u-marg-b-xs u-marg-b-0@sm u-pad-r-w1of24 u-align-left"
              v-html="content.eighth_section_right_number_splitted"
            ></h6>
            <p
              class="t-text--md t-text--roman u-color--gray t-text-lh--md u-w7of10 u-fit-w@sm u-align-left"
            >
              <app-words
                :isActive="isActive"
                :delay="0"
                :content="content.eighth_section_right_text"
              ></app-words>
            </p>
            <span
              class="u-absolute u-pos-tl u-hide@sm u-fit-h c-line--y u-bg--gray u-opacity--30"
            ></span>
          </div>
        </app-scroll-object>
      </div>
    </section>
    <section
      data-color="dark"
      class="c-about__section-hight u-relative u-pad-y-xxl u-pad-y-lg@md js-header-panel"
    >
      <div
        class="c-about__section-hight__wrapper u-marg-l-w3of12 u-marg-x-w3of12@lg u-marg-l-w1of12@sm u-w4of12 u-w1of2@lg u-w10of12@sm"
      >
        <div
          :key="index"
          v-for="(item, index) in content.content_blocks2"
          :class="{ 'u-marg-t-lg': 'title' === item.type.value && index > 0 }"
        >
          <app-scroll-object
            :offset="0"
            :isParallax="!1"
            inline-template
            :content="item"
          >
            <div class="u-marg-x-auto u-fit-w">
              <h2
                class="t-text--xxl t-text-lh--lg t-text--roman u-color--brand-darker"
                v-if="content.type.value === 'title'"
              >
                <app-words
                  :isActive="isActive"
                  :delay="0"
                  :content="content.content"
                ></app-words>
              </h2>
              <p
                class="t-text--xl u-color--gray t-text-lh--xl"
                v-if="content.type.value === 'default'"
                :class="{ 'u-marg-t-md': index > 0 }"
                v-html="content.content"
              ></p>
            </div>
          </app-scroll-object>
        </div>
      </div>
    </section>
   
    <app-footer
      :globalContent="globalContent"
      :adminContent="adminContent"
    ></app-footer>
  </div>
</template>

<script>
import { getAbsoluteBoundingRect } from "../../utilities/getAbsoluteBoundingRect.js";
import AppScrollObject from "../app-scroll-object/index.vue";
import AppFooter from "../app-footer/index.vue";
import AppSlicedText from "../app-sliced-text/index.vue";
import AppRiskTools from "../app-sliced-text/index.vue";
export default {
  props: {
    adminContent: {
      type: Object,
      default: function() {},
    },
    globalContent: {
      type: Object,
      default: function() {},
    },
    headerPageSize: {
      type: Array,
      default: function() {},
    },
    isLoaderActive: {
      type: Boolean,
      default: !0,
    },
  },
  components: {
    "app-footer": AppFooter,
    "app-scroll-object": AppScrollObject,
    "app-sliced-text": AppSlicedText,
    "app-risk-tools": AppRiskTools,
  },
  data: function() {
    return {
      activeFactIndex: -1,
    };
  },
  computed: {
    content: function() {
      return this.adminContent.en.pages.about;
    },
  },
  created: function() {
    (this.content.fifth_section_left_number_splitted = this.content.fifth_section_left_number
      .split("")
      .map(function(t) {
        return "<span class='t-text--roman-italic'>" + t + "</span>";
      })
      .join("")),
      (this.content.fiftha_section_left_number_splitted = this.content.fiftha_section_left_number
        .split("")
        .map(function(t) {
          return "<span class='t-text--roman-italic'>" + t + "</span>";
        })
        .join("")),
      (this.content.eighth_section_left_years_splitted = this.content.eighth_section_left_years
        .split("")
        .map(function(t) {
          return "<span class='t-text--roman-italic'>" + t + "</span>";
        })
        .join("")),
      (this.content.eighth_section_right_number_splitted = this.content.eighth_section_right_number
        .split("")
        .map(function(t) {
          return "<span class='t-text--roman-italic'>" + t + "</span>";
        })
        .join("")),
      (this.onResize = this.onResize.bind(this)),
      (this.onEnterframe = this.onEnterframe.bind(this)),
      this.eventHub.$on("resize", this.onResize),
      this.eventHub.$on("enterframe", this.onEnterframe);
  },
  destroyed: function() {
    this.eventHub.$off("resize", this.onResize),
      this.eventHub.$off("enterframe", this.onEnterframe);
  },
  mounted: function() {
    var t = this;
    this.eventHub.$emit("page:ready"),
      (this.$facts = this.$el.querySelectorAll(".js-fact")),
      (this.$factNav = this.$el.querySelector(".js-facts-nav")),
      (this.$factsSection = this.$el.querySelector(".js-facts-section")),
      (this.factsArray = new Array());
    for (var e = 0; e < this.$facts.length; e++)
      this.factsArray.push({ y: 0, height: 0, isActive: !1 });
    setTimeout(function() {
      t.onResize();
    }, 1e3);
  },
  methods: {
    onResize: function() {
      //this.$el.querySelector("#Layer_1").classList.add('yowananim');
      (this._factsSectionOffsetY = getAbsoluteBoundingRect(
        this.$factsSection
      ).top),
        (this._factsSectionHeight = this.$factsSection.offsetHeight);
      for (var t = 0; t < this.factsArray.length; t++)
        (this.factsArray[t].y = getAbsoluteBoundingRect(this.$facts[t]).top),
          (this.factsArray[t].height = this.$facts[t].offsetHeight);
    },
    onEnterframe: function() {},
    _getPageURLFromWP: function(t) {
      return "/" + t.post_name;
    },
  }
};
</script>
